import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import { Typography, Box, Grid } from '@mui/material';
import MediaTextView from "../components/MediaTextView";
import EventsCalendar from '../components/EventsCalendar';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Feed from '../components/Feed';

const ChannelsPage = () => {
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Box sx={{ flexGrow: 1, p: 2, width: '100%', maxWidth: '100%', m: 0 }}>
                <Grid container spacing={2} sx={{ width: '100%', maxWidth: '100%', m: 0 }}>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Feed
                            channelId="PGKGZQg6sx0RxXOJfnnd"
                            channelOwnerId="gsqJ45OnSOSDphcdAmunvME4VUr1"
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <EventsCalendar
                            channelId="PGKGZQg6sx0RxXOJfnnd"
                            isOwner={true}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <MediaTextView
                            channelId="PGKGZQg6sx0RxXOJfnnd"
                            currentUserId="gsqJ45OnSOSDphcdAmunvME4VUr1"
                            isOwner={true}
                            inputOnTop={false}
                        />
                    </Grid>
                </Grid>
            </Box>
        </LocalizationProvider>
    )
}
export default ChannelsPage;